import { render, staticRenderFns } from "./PasswordWelcome.vue?vue&type=template&id=1a2f9413"
import script from "./PasswordWelcome.vue?vue&type=script&lang=js"
export * from "./PasswordWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports